import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaFacebook, FaInstagram, FaTwitter, FaMapMarkerAlt, FaPhone, FaEnvelope, FaTiktok,FaParking } from 'react-icons/fa';
import { motion } from 'framer-motion';

const Footer = () => {
  const [email, setEmail] = useState('');

  const handleSubscribe = (e) => {
    e.preventDefault();
    // Handle subscription logic here
    alert('Thank you for subscribing!');
    setEmail('');
  };

  return (
    <footer className="bg-primary text-background py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <img src={`${process.env.PUBLIC_URL}/assets/logo.png`} alt="Hotel Admire Pokhara" className="h-12 mb-4" />
            <h3 className="text-xl font-serif font-bold mb-4">Hotel Admire Pokhara</h3>
            <div className="space-y-2 text-background">
              <p className="flex items-center"><FaMapMarkerAlt className="mr-2 text-accent" />Gairikhet Marga Lakeside, Pokhara, Nepal</p>
              <p className="flex items-center"><FaPhone className="mr-2 text-accent" />+977 9856063333/9856032318</p>
              <p className="flex items-center"><FaEnvelope className="mr-2 text-accent" />hoteladmirepokhara@gmail.com</p>
              <p className="flex items-center"><FaParking className="mr-2 text-accent" />Free Parking Available</p>
            </div>
          </div>
          <div>
            <h4 className="text-lg font-serif font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-background hover:text-accent transition-colors duration-300">Home</Link></li>
              <li><Link to="/rooms" className="text-background hover:text-accent transition-colors duration-300">Rooms</Link></li>
              <li><Link to="/gallery" className="text-background hover:text-accent transition-colors duration-300">Gallery</Link></li>
              <li><Link to="/attractions" className="text-background hover:text-accent transition-colors duration-300">Attractions</Link></li>
              <li><Link to="/about" className="text-background hover:text-accent transition-colors duration-300">About</Link></li>
              <li><Link to="/contact" className="text-background hover:text-accent transition-colors duration-300">Contact</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-lg font-serif font-semibold mb-4">Follow Us</h4>
            <div className="flex space-x-4">
              <motion.a href="https://www.facebook.com/hoteladmirepokhara" className="text-2xl text-background hover:text-accent transition-colors duration-300" whileHover={{ scale: 1.1 }}><FaFacebook /></motion.a>
              <motion.a href="https://www.tiktok.com/@hoteladmirepokhara" className="text-2xl text-background hover:text-accent transition-colors duration-300" whileHover={{ scale: 1.1 }}><FaTiktok/></motion.a>
              <motion.a href="https://www.instagram.com/hoteladmirepokhara_?igsh=MXN4cHA0bDR4NGtzbA==" className="text-2xl text-background hover:text-accent transition-colors duration-300" whileHover={{ scale: 1.1 }}><FaInstagram /></motion.a>
            </div>
          </div>
          <div>
            <h4 className="text-lg font-serif font-semibold mb-4">Newsletter</h4>
            <p className="text-background mb-4">Subscribe to get special offers and updates.</p>
            <form onSubmit={handleSubscribe} className="space-y-2">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Your email"
                className="w-full px-3 py-2 bg-highlight border border-accent rounded-md focus:outline-none focus:border-accent text-primary placeholder-secondary"
                required
              />
              <motion.button
                type="submit"
                className="w-full bg-accent hover:bg-accent/90 text-primary font-semibold py-2 px-4 rounded-md transition-colors duration-300 shadow-md hover:shadow-lg"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                Subscribe
              </motion.button>
            </form>
          </div>
        </div>
        <div className="border-t border-accent mt-8 pt-8 text-center text-background">
          <p>&copy; 2025 Hotel Admire Pokhara. All rights reserved. Designed with luxury in mind.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;